export const inviteInitialized = ({}) => {};

export const inviteDeclined = ({}) => {};

export const inviteSent = () => {};

const recommendationsTrackingEvents = ({ roomId }) => {
  return {
    inviteInitialized: ({ seekerId, matchProfile }) =>
      inviteInitialized({ seekerId, roomId, matchProfile }),
    inviteDeclined: ({ seekerId, matchProfile }) =>
      inviteDeclined({ seekerId, roomId, matchProfile }),
    inviteSent: ({ seekerId, matchProfile }) =>
      inviteSent({ seekerId, roomId, matchProfile }),
  };
};

export default recommendationsTrackingEvents;
